<div class="alerts-component">
  <div class="header">
    <span class="title"
      >ALERTS
      <span
        *ngIf="
          visibleItem == 'alertsSettings' || reportsState.forceShowSettings
        "
      >
        SETTINGS</span
      >
    </span>
    <span class="settings-button"
      ><settings-button
        *ngIf="!reportsState.forceShowSettings"
        [svgClass]="visibleItem == 'alertsSettings' ? 'fill-white' : ''"
        (click)="toggleSettings()"
      ></settings-button
    ></span>
  </div>
  <div class="content">
    <alert-settings
      *ngIf="visibleItem == 'alertsSettings' || reportsState.forceShowSettings"
      [alertsSettings]="reportsState.alertSettings"
      (onApplySettings)="saveAlertsSettings($event)"
    ></alert-settings>
    <alerts-type
      *ngIf="visibleItem == 'alertTypes' && !reportsState.forceShowSettings"
      [missingSubtitleReportAlertsStatus]="
        reportsState.missingSubtitleReportStatusText
      "
      [gapsReportStatus]="reportsState.gapsReportStatusText"
      [missingAudiosReportAlertsStatus]="
        reportsState.missingAudiosReportStatusText
      "
      [emptyContractsReportAlertsStatus]="
        reportsState.emptyContractsReportStatusText
      "
      (onShowGapReportClick)="showGapReportClicked()"
      (onShowMissingSubtitleReportClicked)="showMissingSubtitleReportClicked()"
      (onShowMissingAudiosReportClicked)="showMissingAudiosReportClicked()"
      (onShowEmptyContractsReportClicked)="showEmptyContractsReportClicked()"
    ></alerts-type>
  </div>
</div>
